<loading-indicator [show]="!formReady || saving"></loading-indicator>

<div [formGroup]="formData" class="generatedHTMLWindow generatedHTMLForm angularForm" *ngIf="formReady">
  <div class="formHeader">
    <span class="navigateBtn navigate-left" (click)="previous()" *ngIf="showPrevBtn && currentOid > 0">
      <svg-icon title="{{'navigation.previous' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
    <span class="headerTitle">{{ 'comparablesLease.leaseDetails' | translate }}</span>
    <span class="navigateBtn navigate-right" (click)="next()" *ngIf="showNextBtn && currentOid > 0">
      <svg-icon title="{{'navigation.next' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
  </div>
  <div class="generatedHTMLRoot">
    <div class="mainSection">
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'comparablesLease.leaseInformation' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.TenantFileRefNo' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="TenantFileRefNo" kendoTextBox id="form-TenantFileRefNo" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.LeaseName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="LeaseName" kendoTextBox id="form-LeaseName" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.Sector' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Sector" kendoTextBox id="form-Sector" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.Region' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Region" kendoTextBox id="form-Region" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.TenantUse' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="TenantUse" kendoTextBox id="form-TenantUse" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.LeaseStart' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="LeaseStart" id="form-LeaseStart"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.Covenant' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Covenant" kendoTextBox id="form-Covenant" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ValuationMethod' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="ValuationMethod" kendoTextBox id="form-ValuationMethod" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PeriodToExpiry' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PeriodToExpiry" format="n2" [spinners]="false" id="form-PeriodToExpiry"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.BreakType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="BreakType" kendoTextBox id="form-BreakType" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PeriodToTermination' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PeriodToTermination" format="n2" [spinners]="false" id="form-PeriodToTermination"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.VoidExpiryByBreak' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="VoidExpiryByBreak" format="n2" [spinners]="false" id="form-VoidExpiryByBreak"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.GroundRent' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="GroundRent" format="n2" [spinners]="false" id="form-GroundRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ContractedRent' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ContractedRent" format="n2" [spinners]="false" id="form-ContractedRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.RentalValue' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="RentalValue" format="n2" [spinners]="false" id="form-RentalValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ErvRatePerSqft' | translate }} | {{unitOfLength}}²</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvRatePerSqft" format="n2" [spinners]="false" id="form-ErvRatePerSqft"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.RentRatePerSqft' | translate }} | {{unitOfLength}}²</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="RentRatePerSqft" format="n2" [spinners]="false" id="form-RentRatePerSqft"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PercentErv' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErv" format="n2" [spinners]="false" id="form-PercentErv"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PercentRent' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentRent" format="n2" [spinners]="false" id="form-PercentRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ErvUplift' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvUplift" format="n2" [spinners]="false" id="form-ErvUplift"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="inlineBlockHeader">
            &nbsp;
          </div>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PercentErvUpliftPerRent' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErvUpliftPerRent" format="n2" [spinners]="false" id="form-percentErvUpliftPerRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PercentErvUpliftPerTotalRent' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErvUpliftPerTotalRent" format="n2" [spinners]="false" id="form-percentErvUpliftPerTotalRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.CostDeductions' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="CostDeductions" format="n2" [spinners]="false" id="form-costDeductions"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.CapitalisationGroup' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="CapitalisationGroup" kendoTextBox id="form-capitalisationGroup" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.currency' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="currencyId"
                                      [data]="reflistData.ref_currency_with_code"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onCurrencyChanged($event)"
                                      id="form-currency">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.unitOfLength' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="unitOfLengthId"
                                      [data]="reflistData.ref_unit_of_length"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onUnitOfLengthChanged($event)"
                                      id="form-unitofLength">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer noBorder">
          <span class="sectionTitle">&nbsp;</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.LeaseType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="LeaseType" kendoTextBox id="form-leaseType" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.UnitDescription' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="UnitDescription" kendoTextBox id="form-unitDescription" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PrimaryUse' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="PrimaryUse" kendoTextBox id="form-primaryUse" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.Status' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="Status" kendoTextBox id="form-status" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.LeaseExpiry' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="LeaseExpiry" id="form-leaseExpiry"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.AreaSqft' | translate }} | {{unitOfLength}}²</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="AreaSqft" format="n2" [spinners]="false" id="form-areaSqft"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.NextReview' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="NextReview" id="form-nextReview"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.EarliestTermination' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="EarliestTermination" id="form-earliestTermination"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.EffectiveBreak' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="EffectiveBreak" id="form-effectiveBreak"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PeriodToBreak' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PeriodToBreak" format="n2" [spinners]="false" id="form-periodToBreak"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.RentFreePeriod' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="RentFreePeriod" format="n2" [spinners]="false" id="form-rentFreePeriod"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.DeemedRent' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="DeemedRent" format="n2" [spinners]="false" id="form-deemedRent"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.GrossValue' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="GrossValue" format="n2" [spinners]="false" id="form-grossValue"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.VacantPeriod' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="VacantPeriod" format="n2" [spinners]="false" id="form-vacantPeriod"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ErvVacancyLoss' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvVacancyLoss" format="n2" [spinners]="false" id="form-ervVacancyLoss"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.Froth' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="Froth" format="n2" [spinners]="false" id="form-froth"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PercentErvVacancyLoss' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentErvVacancyLoss" format="n2" [spinners]="false" id="form-percentErvVacancyLoss"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.PercentFroth' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="PercentFroth" format="n2" [spinners]="false" id="form-percentFroth"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ErvVoidLoss' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ErvVoidLoss" format="n2" [spinners]="false" id="form-ervVoidLoss"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer emptyLabel"></div>
                <div class="fieldContainer emptyField"></div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="sectionTitleContainer inlineBlockHeader">
            <span class="sectionTitle">{{ 'comparablesLease.yieldInformation' | translate | uppercase}}</span>
          </div>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.HardcoreYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="HardcoreYield" format="n2" [spinners]="false" id="form-hardcoreYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.FrothYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="FrothYield" format="n2" [spinners]="false" id="form-frothYield"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.DcfExitYld' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="DcfExitYld" format="n2" [spinners]="false" id="form-dcfExitYld"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ReversionYield' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ReversionYield" format="n2" [spinners]="false" id="form-reversionYield"></kendo-numerictextbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">PROJECT / SYSTEM INFORMATION</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.projectPuid' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ProjectPuid"
                                      #projectRetriever
                                      [data]="retrieverData.Project"
                                      textField="projectName"
                                      [filterable]="true"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onProjectSelected()"
                                      id="form-projectPUID">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.valuationPortfolio' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ValuationId"
                                      #valuationEventRetriever
                                      [data]="retrieverData.ValuationPortfolio"
                                      textField="ValuationPortfolioName"
                                      [filterable]="true"
                                      valueField="id"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onValuationEventSelected()"
                                      id="form-valuationID">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ownerUserID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerUserID"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.modifiedByUserId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ModifiedByUserId"
                                      [data]="reflistData.config_user"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-modifiedBy">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.createdDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="CreatedDate" id="form-createdAt"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.modifiedDate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-datepicker formControlName="ModifiedDate" id="form-modifiedat"></kendo-datepicker>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.ownerBuID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="OwnerBuID"
                                      [data]="reflistData.config_business_units"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-createdByBu">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.modifiedBuID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ModifiedBuID"
                                      [data]="reflistData.config_business_units"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-modifiedByBu">
                  </kendo-dropdownlist>
                </div>
              </div>

              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesLease.oid' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" *ngIf="isNew" formControlName="filledOnSave" kendoTextBox id="form-oid" />
                  <input type="text" *ngIf="!isNew" formControlName="oid" kendoTextBox id="form-oid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">PROPERTY INFORMATION</span>

        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.propertyID' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="PropertyId"
                                      #propertyRetriever
                                      [data]="retrieverData.Property"
                                      textField="description"
                                      [filterable]="true"
                                      valueField="OID"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onPropertySelected()"
                                      id="form-PropertyId">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.buildingName' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="BuildingName" kendoTextBox id="form-propertyname" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-propertyname" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.propertyType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="PropertyPrimaryUse" kendoTextBox id="form-propertyType" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-propertyType" />
                </div>
              </div>
              <div class="field width100percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.street' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="StreetName" kendoTextBox id="form-street" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-street" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberFrom' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="NumberFrom" kendoTextBox id="form-numberFrom" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-numberFrom" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberTo' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="NumberTo" kendoTextBox id="form-numberTo" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-numberTo" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.numberAdd' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="NumberAdd" kendoTextBox id="form-numberAdd" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-numberAdd" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.postCode' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="ZipCode6" kendoTextBox id="form-postCode" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-postCode" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.city' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="City" kendoTextBox id="form-city" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-city" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.region' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="PropertyRegion" kendoTextBox id="form-region2" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-region2" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.subMarket' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="SubMarket" kendoTextBox id="form-subMarket" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-subMarket" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.country' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="Country" kendoTextBox id="form-country" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-country" />
                </div>
              </div>
              <div class="field width33percent"><div class="labelContainer emptyLabel"></div><div class="fieldContainer emptyField"></div></div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.constructionYear' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="ConstructionYear" kendoTextBox id="form-constructionYear" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-constructionYear" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.renovationYear' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="RenovationYear" kendoTextBox id="form-renovationYear" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-renovationYear" />
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'comparablesValuation.energyLabel' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="text" formControlName="energyLabelDescription" kendoTextBox id="form-energyLabel" />
                  <input *ngIf="isNew" type="text" formControlName="filledWithProperty" kendoTextBox id="form-energyLabel" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
